import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TokenComponent } from './components/token/token.component';
import { SlugPageComponent } from './components/slugPage/slug-page.component';
import { LayoutComponent } from './layout/layout/layout.component';
import { TokenGuard } from './guards/token.guard';
import { PermissionsGuard } from './guards/permissions.guard';
import { SettingsComponent } from './components/settings/settings.component';
import { AdminSetariComponent } from './platform/nomenclatoare/admin-setari/admin-setari.component';
import { AccesInterzisComponent } from './shared/acces-interzis/acces-interzis.component';
import { CereriComponent } from './components/cereri/cereri.component';
import { ContracteProgramari } from './components/activitati/contracte-programari/contracte-programari.component';
import { CopiiComponent } from './components/activitati/copii/copii.component';
import { ProgramComponent } from './components/activitati/program/program.component';
import { SettingsActivitiesComponent } from './components/activitati/settings-activities/settings-activities.component';
import { ScansComponent } from './components/activitati/scans/scans.component';
import { ConfirmareDocumenteComponent } from './components/confirmare-documente/confirmare-documente.component';
import { NotificariComponent } from './components/notificari/notificari.component';
import { SettingsActivitiesDocsComponent } from './components/activitati/settings-activities-docs/settings-activities-docs.component';
import { SettingsActivitiesProgComponent } from './components/activitati/settings-activities-prog/settings-activities-prog.component';
import { BeneficiariComponent } from './components/activitati/beneficiari/beneficiari.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/cereri',
        pathMatch: 'full',
    },
    {
        path: 'access-denied',
        component: AccesInterzisComponent,
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [TokenGuard, PermissionsGuard],
        children: [
            {
                path: 'cereri',
                component: CereriComponent,
            },
            {
                path: 'confirmare-documente',
                component: ConfirmareDocumenteComponent,
            },
            {
                path: 'notificari',
                component: NotificariComponent,
            },
            {
                path: 'settings',
                component: SettingsComponent,
            },
            {
                path: 'contracte-programari',
                component: ContracteProgramari,
            },
            {
                path: 'beneficiari',
                component: BeneficiariComponent,
            },
            {
                path: 'scans',
                component: ScansComponent,
            },
            {
                path: 'program',
                component: ProgramComponent,
            },
            {
                path: 'inregistrare-programare',
                loadChildren: () => import('./components/activitati/inregistrare-programare/inregistrare-programare.module').then(m => m.InregistrareProgramareModule)
            },
            {
                path: 'settings-activities',
                component: SettingsActivitiesComponent,
            },
            {
                path: 'settings-activities-docs',
                component: SettingsActivitiesDocsComponent,
            },
            {
                path: 'settings-activities-prog',
                component: SettingsActivitiesProgComponent,
            },
            {
                path: 'admin-settings',
                component: AdminSetariComponent,
            },
            {
                path: 'programari-calendar',
                loadChildren: () => import('./components/activity-schedule/activity-schedule.module').then(m => m.ActivityScheduleModule)
            },
            {
                path: 'user-profile',
                loadChildren: () => import('./components/user-profile/user-profile.module').then(m => m.UserProfileModule)
            },
            {
                path: 'gestiune-ajutoare',
                loadChildren: () => import('./components/gestiune-ajutoare/gestiune-ajutoare.module').then(m => m.GestiuneAjutoareModule)
            },
            { path: ':slug', component: SlugPageComponent },
        ],
    },
    {
        path: 'token/:token',
        component: TokenComponent,
    },
    {
        path: '**',
        redirectTo: '/cereri',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            useHash: true,
        }),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
